// SignOutButton — the way out, which existed as a ROUTE and not as a control.
//
// Alex, 2026-08-27: "Note that I do not think we have a logout?" He was right in
// the way that matters. `/auth/logout` has worked since sign-in shipped, but
// nothing in src/web ever linked to it — zero matches for "logout" across the
// whole UI — so the only way to end a session was to know the URL and type it.
//
// ⚠ IT IS AN <a>, NOT A BUTTON WITH A fetch. Signing out is a top-level
// navigation: the server clears the cookie on the response and lands you back at
// the app, which then re-checks /auth/me and shows the sign-in card. A fetch
// would clear the cookie and leave the page sitting there still looking signed
// in, which is the state most likely to be mistaken for "it did not work".
//
// Hidden entirely in single-user mode (`enabled: false`) — offering to end a
// session that does not exist would be a control that cannot do anything.

import { useAuth } from '../AuthGate.jsx';

export default function SignOutButton() {
  const { enabled, signedIn, who } = useAuth();
  if (!enabled || !signedIn) return null;
  return (
    <span style={{ display: 'inline-flex', alignItems: 'center', gap: 6 }}>
      <span
        title={`Signed in as ${who}`}
        style={{
          color: 'var(--th-navy-text-muted)', fontSize: 'var(--fs-small)',
          maxWidth: 160, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap',
        }}
      >{who}</span>
      <a
        href="/auth/logout"
        title="End this session and return to the sign-in screen"
        style={{
          color: 'var(--th-bar-text)', fontSize: 'var(--fs-small)',
          textDecoration: 'none', padding: '2px 8px', borderRadius: 4,
          border: '1px solid var(--th-bar-border)', whiteSpace: 'nowrap',
        }}
      >Sign out</a>
    </span>
  );
}
